import React from 'react';
import { 
	connectHighlight
} from 'react-instantsearch-dom';

export default connectHighlight(({ highlight, attribute, hit }) => {
	const highlights = highlight({
		highlightProperty: '_highlightResult',
		attribute,
		hit
	});

	return highlights.map(part => part.isHighlighted ? (
		<mark key={part.value}>{part.value}</mark>
	) : (
		<span key={part.value}>{part.value}</span>
	));
}
);
